export default {
  title: 'Payment',
  description: 'All transactions are secure and encrypted',
  show_more_payment_methods: 'Show more payment methods',
  express_checkout_divider: 'or',
};
